import { fromJS } from 'immutable';

import * as constants from 'actions/projects/constants';
import uiRecord from 'reducers/ui/records';

// Start the loader to true, as the Root page will not be ready
// until all projects are fetched
export const initialState = uiRecord({ loader: true });

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_ALL_PROJECTS:
      return uiRecord({
        loader: true
      });

    case constants.GET_ALL_PROJECTS_SUCCESS:
      return uiRecord();

    case constants.GET_ALL_PROJECTS_ERROR:
      return uiRecord({
        error: fromJS(action.error)
      });

    default:
      return state;
  }
};
